import { render, staticRenderFns } from "./GiftcardView.vue?vue&type=template&id=c0dd6bac"
import script from "./GiftcardView.vue?vue&type=script&lang=js"
export * from "./GiftcardView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports